// extracted by mini-css-extract-plugin
export default {"brand_avatar_container":"brand-avatar_brand_avatar_container__T8vKH"};